import { Map, OrderedMap } from 'immutable';
import { Fun } from 'widgets-for-react';
import { ApiResult } from '../apiTypes';
import { catchError } from '../apiUtils';
import { Teaser } from '../drupal/drupalTypes';
import { SearchablePage } from './elasticsearchTypes';

export const getTeasers: Fun<string[], Promise<ApiResult<Map<string, Teaser>>>> = (ids) => new Promise(async res => {
  // Add XSRF token to headers
  let headers = new Headers()
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  try {
    // Build params
    const searchParams = new URLSearchParams();
    ids.forEach(id => searchParams.append("entityIds", id))

    let teasers = await fetch(`/api/v1/search/getByIds?${searchParams.toString()}`, { headers })
      .then(x => (x.status == 200 ? x.json() : Promise.reject(x.statusText)))
      .then((x: SearchablePage[]) => x.map<Teaser>(item => ({
        id: item.EntityId.toString(),
        title: item.Title,
        url: item.Url,
        imageUrl: item.ImageUrls["400x280"],
        imageUrlLarge: item.ImageUrls["800x560"],
        imageAlt: item.ImageAlt,
        description: item.Description,
      })))
      .catch(catchError<Teaser[]>());

    if (teasers == 'error' || teasers == 'loading') throw new Error('Could not load teasers')

    res(
      OrderedMap<string, Teaser>(teasers.map(t => [t.id, t]))
    )
  } catch (e) {
    console.error(e)
    res('error')
  }
})